import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Col, message, Pagination, Row, Select, Empty, Spin } from "antd";
import * as ChaptersActions from "../../../../../Redux/Actions/ChaptersActions";
import pause from "../../../../../Assets/Images/pause.svg";
import play from "../../../../../Assets/Images/play.svg";
import trash from "../../../../../Assets/Images/delete.svg";
import edit from "../../../../../Assets/Images/edit.svg";
import add from "../../../../../Assets/Images/add.svg";
import chapters from "../../../../../Assets/Images/chapters.svg";
import userIcon from "../../../../../Assets/Images/user.png";
import clockIcon from "../../../../../Assets/Images/time.png";
import eyeIcon from "../../../../../Assets/Images/eye.png";
import "./Chapters.scss";
import moment from "moment";
import { itemRender } from "../../../../../Components/commonCode";

const { Option } = Select;
const Chapters = ({
  chaptersData,
  totalChaptersCount,
  searchText,
  getChaptersData,
  toggleChapterAction,
  deleteChapter,
  history,
}) => {
  const searchParams = new URLSearchParams(window.location.search);
  const rawPage = parseInt(searchParams.get("page")) || 1;
  const initialPage = isNaN(rawPage) || rawPage < 1 ? 1 : rawPage;

  const user = JSON.parse(localStorage.getItem("userdata"));
  const [page, setPage] = useState(initialPage);
  const [totalCount, setTotalCount] = useState(totalChaptersCount);
  const [pageSize, setPagesize] = useState(10);
  const [fetchData, setFetchData] = useState(false);
  const [loader, setLoader] = useState(true);

  //  Fetches chapters data based on page, page size, and search text.
  useEffect(() => {

    const params = new URLSearchParams(window.location.search);
    if (params.get("page") !== page.toString()) {
      params.set("page", page.toString());
      const newUrl = `${window.location.pathname}?${params.toString()}`;
      window.history.replaceState({}, '', newUrl);
    }

    let data = {
      page_num: page,
      page_size: pageSize,
      ...(searchText !== "" &&
        searchText !== null &&
        searchText !== undefined && {
        is_search: true,
        search_text: searchText,
      }),
    };
    const timeoutId = setTimeout(() => {
      setLoader(true)
      getChaptersData(user?.id, data, res => {
        setLoader(false)
        const maxPage = Math.ceil((res?.total_count || 0) / pageSize);
        setTotalCount(res?.total_count || 0);

          if (page > maxPage && maxPage > 0) {
            setPage(maxPage);
          }
          
      }, err => {
        setLoader(false)
      });
    }, 500);
    return () => clearTimeout(timeoutId);
  }, [page, pageSize, fetchData, searchText]);

  /**
   * Toggles the active state of a chapter.
   * @param {Event} e - The event object.
   * @param {Object} chapter - The chapter object.
   */
  const onToggleChapterAction = (e, chapter) => {
    e.stopPropagation();
    let data = {
      is_active: !chapter?.is_active,
      chapter_id: chapter?.id,
    };
    toggleChapterAction(data, user?.id)
      .then(() => {
        message.success("Updated..");
      })
      .catch((e) => {
        message.error(e || "Something went wrong..");
      });
  };

  /**
   * Deletes a chapter.
   * @param {Event} e - The event object.
   * @param {string} id - The ID of the chapter to be deleted.
   */
  const onDeleteChapter = (e, id) => {
    e.stopPropagation();
    let data = {
      chapter_id: id,
      delete: true,
    };
    deleteChapter(data, user?.id)
      .then(() => {
        setFetchData(!fetchData);
        message.success("Deleted");
        const itemsPerPage = Math.min(pageSize, totalCount - (page - 1) * pageSize);

        if (itemsPerPage === 1) {
          setPage(Math.max(1, page - 1));
        }
      })
      .catch((e) => {
        message.error(e || "Failed to delete");
      });
  };

  /**
   * Redirects to the chapter edit page.
   * @param {Event} e - The event object.
   * @param {Object} item - The chapter object to be edited.
   */
  const onEditChapter = (e, item) => {
    e.stopPropagation();
    history.push(`/education/learn-series65/chapter-edit/${item?.id}`);
  };

  return (
    <div className="chapters-container">
      <div className="chapters-header">
        <h6>Chapters</h6>
        <div className="header-right">
          <p
            onClick={() =>
              history.push("/education/learn-series65/add-chapter")
            }
          >
            <img src={add} alt="add" />
            <span>Add New</span>
          </p>
          <Select
            defaultValue={10}
            className="selection-menu"
            onChange={(value) => setPagesize(value)}
          >
            <Option value={10}>10</Option>
            <Option value={50}>50</Option>
          </Select>
        </div>
      </div>
      <div className="chapters-list-groups">
        {loader ? (
          <Spin />
        ) : (
          <>
            {chaptersData?.length == 0 ? (
              <Empty description="No Chapters" />
            ) : chaptersData?.map((item) => (
              <Row
                className="single-list"
                onClick={() =>
                  history?.push({
                    pathname: `/education/learn-series65/chapter-detail/${item?.id}`,
                    state: { searchPlaceholder: "Search Chapter", back: true }
                  })
                }
              >
                <Col span={1}>
                  <div className="icon-box">
                    <img src={chapters} alt="chapters" />
                  </div>
                </Col>
                <Col span={16} className="title">
                  <h6>Chapter {item?.chapter_number}
                    {item?.is_draft ? <span className="draftBadge">Draft</span> :
                      item?.publish_date && moment.utc(item?.publish_date).local().isAfter(moment()) ? <span className="publishBadge">
                        <img src={clockIcon} alt="clock" />
                        {`Schedule Publish on: ${moment.utc(item?.publish_date).local().format('D MMMM, YYYY [at] HH:mm:ss')}`}
                      </span> : null}
                  </h6>
                  <Row>
                    <Col span={24}>
                      <span>{item?.title}</span>
                    </Col>
                  </Row>
                  <Row gutter={16} className="author-details">
                    <Col span={12}>
                      <span>
                        <img src={userIcon} alt="user" /> By {item?.created_by}
                        <img src={clockIcon} alt="clock" /> {item?.created}
                        <img src={eyeIcon} alt="eye" /> Views :
                        {item?.total_views || 0}
                      </span>
                    </Col>
                  </Row>
                </Col>
                <Col span={3} offset={2} className="icon-group">
                  <img
                    src={item?.is_active ? pause : play}
                    alt="Pause"
                    onClick={(e) => onToggleChapterAction(e, item)}
                  />
                  <img
                    src={edit}
                    alt="Edit"
                    onClick={(e) => onEditChapter(e, item)}
                  />
                  <img
                    src={trash}
                    alt="Delete"
                    onClick={(e) => onDeleteChapter(e, item?.id)}
                  />
                </Col>
              </Row>
            ))}
          </>
        )}
      </div>
      {totalCount > 0 && !loader && (
        <div className="pagination">
          <Pagination
            total={totalCount}
            itemRender={itemRender}
            pageSize={pageSize}
            current={page}
            onChange={(page) => setPage(page)}
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    chaptersData: state.Chapter.chaptersData,
    totalChaptersCount: state.Chapter.totalChaptersCount,
    searchText: state.Search.searchText,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getChaptersData: (id, data, onSuccess, onFail) =>
      dispatch(ChaptersActions.getLearnSeriesChaptersData(id, data, onSuccess, onFail)),
    toggleChapterAction: (data, id) =>
      dispatch(ChaptersActions.toggleChapterAction(data, id)),
    deleteChapter: (data, id) =>
      dispatch(ChaptersActions.deleteChapter(data, id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Chapters);
